export const isMobile = (() => {
  if (typeof navigator === 'undefined' || typeof navigator.userAgent !== 'string') {
    return false;
  }
  return /Mobile/.test(navigator.userAgent);
})();

// 부모 앱이 iframe URL 로 넘겨주는 파라미터(displayName, locale 등)를 읽는다.
export function getParameterByName(name: string) {
  let url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// This function ensures that the user has granted the browser permission to use audio and video
// devices. If permission has not been granted, it will cause the browser to ask for permission
// for audio and video at the same time (as opposed to separate requests).
export function ensureMediaPermissions() {
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    throw 'ex=>' + navigator;

    // return navigator.mediaDevices
    //   .getUserMedia({ audio: true, video: true })
    //   .then(mediaStream => mediaStream.getTracks().forEach(track => track.stop()))
    //   .catch(ex2 => {
    //     throw console.error(ex2);
    //   });
    //throw 'enumerateDevices()를 지원하지 않습니다.';
  }
  return navigator.mediaDevices
    .enumerateDevices()
    .then(devices => devices.every(device => !(device.deviceId && device.label)))
    .then(shouldAskForMediaPermissions => {
      console.log(shouldAskForMediaPermissions, 'shouldAskForMediaPermissions2');

      if (shouldAskForMediaPermissions) {
        return (
          navigator.mediaDevices
            .getUserMedia({ audio: true, video: true })
            //.then(mediaStream => mediaStream.getTracks().forEach(track => track.stop()));
            .then(mediaStream => {
              console.log(mediaStream, 'mediaStream2');
              console.log(mediaStream.getTracks().length, 'mediaStream.getTracks()');
              mediaStream.getTracks().forEach(track => track.stop());
            })
            .catch(e => {
              console.log(e, 'e');
            })
        );
      }
    });
}
